module.exports = __webpack_public_path__ + "components/weather-icon/static/daylightrain-11a7b5cdcd4f411a691a7fa4f016160b.svg";